import { ref } from 'vue';
import { useToasted } from './useToasted';

export const useCopyText = () => {
    const toasted = useToasted();

    const copiedText = ref('');

    let copiedTextTimeout;
    const copyText = (text, showToasted = true) => {
        navigator.clipboard.writeText(text);
        showToasted && toasted.success(`${text} copied to clipboard.`);

        copiedText.value = text;

        clearTimeout(copiedTextTimeout);
        copiedTextTimeout = setTimeout(() => {
            copiedText.value = '';
        }, 1000);
    };

    return {
        copiedText,
        copyText,
    };
};
